/**
 * Read Meta Pixel attribution cookies set by fbevents.js.
 * Used to propagate fbp/fbc through Stripe Checkout metadata so the
 * server-side CAPI Purchase event matches against the browser's pixel
 * identity (EMQ uplift).
 *
 * - _fbp: first-party browser-id cookie set by the pixel on every page.
 *   Format: "fb.<subdomainIndex>.<creationTime>.<randomNumber>"
 * - _fbc: first-party click-id cookie set when the user arrives from a
 *   Meta ad with an fbclid URL param.
 *   Format: "fb.<subdomainIndex>.<creationTime>.<fbclid>"
 *
 * Returns undefined for either if the cookie is absent.
 */

export interface MetaCookies {
  fbp?: string;
  fbc?: string;
}

export function readMetaCookies(): MetaCookies {
  if (typeof document === 'undefined' || !document.cookie) return {};
  const result: MetaCookies = {};
  const parts = document.cookie.split(';');
  for (const part of parts) {
    const eq = part.indexOf('=');
    if (eq === -1) continue;
    const name = part.slice(0, eq).trim();
    const value = part.slice(eq + 1).trim();
    if (name === '_fbp' && value) result.fbp = value;
    else if (name === '_fbc' && value) result.fbc = value;
  }
  return result;
}
